module.exports = __webpack_public_path__ + "32a86ba335a09b6254ae08c1efb4ce50.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/dropdown.svg
// module id = 1315
// module chunks = 65